import { render, staticRenderFns } from "./messageCount.functional.vue?vue&type=template&id=a3934e6c&functional=true"
var script = {}
import style0 from "./messageCount.functional.vue?vue&type=style&index=0&id=a3934e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports